export default "__VITE_ASSET__BYTTHgTd__"